import { LoadingHeading, LoadingParagraph, LoadingText } from '@zg-rentals/loading-components';
import { Box, Page } from '@zillow/constellation-10';

// Full-page loading skeleton used while the renter dashboard is fetching
// state or while a redirect to Your Rental is in flight (TM-952).
const HomePageSkeleton = () => (
  <Page.Root css={{ backgroundColor: 'bg.neutral' }}>
    <Page.Header>
      <LoadingHeading isLoading level={1} loadingWidth="240px">
        Loading...
      </LoadingHeading>
    </Page.Header>
    <Page.Content>
      <Box css={{ marginBottom: 'looser' }}>
        <LoadingHeading isLoading level={2} textStyle="heading-sm" loadingWidth="180px">
          Loading...
        </LoadingHeading>
        <LoadingParagraph isLoading loadingWidth="90%" css={{ marginTop: 'default' }}>
          Loading...
        </LoadingParagraph>
        <LoadingParagraph isLoading loadingWidth="70%" css={{ marginTop: 'tight' }}>
          Loading...
        </LoadingParagraph>
      </Box>

      <Box css={{ marginBottom: 'looser' }}>
        <LoadingHeading isLoading level={3} textStyle="heading-xs" loadingWidth="140px">
          Loading...
        </LoadingHeading>
        <LoadingText isLoading loadingWidth="55%" css={{ marginTop: 'tight' }}>
          Loading...
        </LoadingText>
      </Box>

      <Box>
        <LoadingParagraph isLoading loadingWidth="80%" css={{ marginBottom: 'tight' }}>
          Loading...
        </LoadingParagraph>
        <LoadingParagraph isLoading loadingWidth="65%" css={{ marginBottom: 'tight' }}>
          Loading...
        </LoadingParagraph>
        <LoadingParagraph isLoading loadingWidth="40%">
          Loading...
        </LoadingParagraph>
      </Box>
    </Page.Content>
  </Page.Root>
);

export default HomePageSkeleton;
